<template>
  <div class="opportunities-filters">
    <OpportunityStatusChip
      :value="searchFilters.opportunityStatusId"
      :statuses="opportunityStatuses"
      @change="$emit('status-filter-change', $event)"
    />
    <VoteChip
      v-if="tenantHasGonogoAccess() && users"
      :value="searchFilters.voterId"
      :users="users"
      @change="$emit('voter-filter-change', $event)"
    />
    <DocumentChip
      v-if="tenantHasDocumentsAccess()"
      :value="searchFilters.hasDocuments"
      @change="$emit('document-filter-change', $event)"
    />
    <CreatorChip
      v-if="users"
      :value="searchFilters.authorId"
      :users="users"
      @change="$emit('creator-filter-change', $event)"
    />
    <AssigneesChip
      v-if="users"
      :value="searchFilters.assigneeId"
      :users="users"
      @change="$emit('assignee-filter-change', $event)"
    />
    <LabelsChip
      v-if="opportunityLabels && opportunityLabels.length"
      :value="searchFilters.labelId"
      :labels="opportunityLabels"
      @change="$emit('label-filter-change', $event)"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import OpportunityStatusChip from '@/components/filters/dimensions/OpportunityStatusChip';
import VoteChip from '@/components/filters/dimensions/VoteChip';
import DocumentChip from '@/components/filters/dimensions/DocumentChip';
import CreatorChip from '@/components/filters/dimensions/CreatorChip';
import AssigneesChip from '@/components/filters/dimensions/AssigneesChip';
import LabelsChip from '@/components/filters/dimensions/LabelsChip';

import { tenantHasDocumentsAccess, tenantHasGonogoAccess } from '@/util/module-access-util';

/**
 * Opportunities filter bar, converged to the presentational chip kit. Owns the page-level data
 * the chips need (opportunity statuses, user roster, opportunity labels) and gates the
 * vote/document dimensions on tenant module access. The labels chip only shows once the tenant
 * has at least one label. Re-emits the same events PageOpportunities already handles.
 */
export default {
  name: 'OpportunitiesFilters',
  components: { OpportunityStatusChip, VoteChip, DocumentChip, CreatorChip, AssigneesChip, LabelsChip },
  props: {
    searchFilters: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('tenant', ['users']),
    ...mapGetters('opportunityStatuses', ['opportunityStatuses']),
    ...mapGetters('opportunityLabels', ['opportunityLabels']),
  },
  methods: {
    tenantHasGonogoAccess,
    tenantHasDocumentsAccess,
  },
};
</script>

<style lang="scss">
.opportunities-filters {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 0;
}
</style>
